import { render, staticRenderFns } from "./CanDictionary.vue?vue&type=template&id=847494b6&scoped=true&"
import script from "./CanDictionary.vue?vue&type=script&lang=ts&"
export * from "./CanDictionary.vue?vue&type=script&lang=ts&"
import style0 from "./CanDictionary.vue?vue&type=style&index=0&id=847494b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847494b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
